module.exports = __webpack_public_path__ + "static/img/spdx.32a5922.gif";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/fiveG/function/spdx.gif
// module id = LenI
// module chunks = 1